import idConstants from '../data/idConstants';

const { pricingPlanTypes, workflowVariantCode } = idConstants;

/**
 * Returns the billing type code string based on plan details.
 * @param {object} planDetails - pricing plan object with planType, paymentType, paymentModePref, occurrence
 * @returns {string} workflowVariantCode value
 */
export const getWorkflowVariantCodeFromPlanType = (planDetails) => {
  const planInfo =
    planDetails?.planDetails?.planType +
    '_' +
    planDetails?.planDetails?.paymentType +
    '_' +
    planDetails?.planDetails?.paymentModePref;

  if (planInfo === pricingPlanTypes.flatRatePrepaidStandard || planInfo === pricingPlanTypes.usageBasedPrepaidStandard)
    return workflowVariantCode.uzos.standardBilling;
  if (planInfo === pricingPlanTypes.flatRatePrepaidApproval || planInfo === pricingPlanTypes.usageBasedPrepaidApproval)
    return workflowVariantCode.uzos.approvalBilling;
};
